<template>
    <div class="modal fade" id="phoneNumberNotExistModal" tabindex="-1" role="dialog" data-backdrop="static"
         aria-labelledby="phoneNumberNotExistModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-content-flex-container">
                        <div class="info-container">
                            <img src="../../assets/information-green.png" alt="info">
                        </div>
                        <div class="text-container">
                            <p>Please add mobile number to your account to enable two-factor-authentication</p>
                        </div>
                        <div class="go-to-settings-button-container">
                            <p>Go to Account Page</p>
                            <img @click="goToAccountPage" src="../../assets/right-arrow-blue.png" alt="go">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "phoneNumberNotExist",
        methods: {
            goToAccountPage() {
                this.$emit("goToAccountPage")
            },
            showModal() {
                $('#phoneNumberNotExistModal').modal('show');
            },
            hideModal() {
                $('#phoneNumberNotExistModal').modal('hide');
            }
        },
        mounted() {
            $('#phoneNumberNotExistModal').modal({show: false});
        }
    }
</script>

<style scoped>
    .modal-content-flex-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .go-to-settings-button-container {
        display: flex;
        flex-direction: row;
        align-self: flex-end;
        align-items: center;
    }

    .go-to-settings-button-container img {
        width: 48px;
        height: 48px;
        margin-left: 24px;
        cursor: pointer;
    }

    .info-container img {
        width: 48px;
        height: 48px;
    }

    .go-to-settings-button-container p {
        color: white;
        margin: 0;
    }

    .text-container {
        color: #00FEAB;
    }

    .text-container p{
        text-align: center;
    }

    .modal-content-flex-container div {
        margin: 16px 0 0 0;
    }

    #phoneNumberNotExistModal {
        z-index: 100001;
    }

    .modal-dialog {
        height: 25% !important;
        width: 20% !important;
    }

    .modal-content {
        height: 100% !important;
        background-color: #002428 !important;
        overflow: hidden;
    }

    .modal-body {
        max-height: 88% !important;
    }

    h1 {
        color: limegreen;
        font-family: 'Digital-Serial-Bold' !important;
    }

    p, label {
        font-family: 'Digital-Serial-Bold' !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/PhoneNumberNotExistModal.vue